import styled from 'styled-components'

export const FormContainer = styled.div`
  > div {
    width: 100%;
    max-width: 500px;
  }
`
